module.exports = __webpack_public_path__ + "img/micro-access.00362cb6.svg";